import { Components } from "@react-admin/ra-enterprise";

export const RaReferenceField: Components["RaReferenceField"] = {
  styleOverrides: {},
};
